export const FEATURE_MAP = {
  audit: {
    id: "audit",
    name: "Audit",
    type: "page",
    route: "/new-audit-projects",
    fallbackPriority: 1,
  },
  auditOverview: {
    id: "auditOverview",
    name: "Audit Overview",
    type: "page",
    route: "/audits/overview",
  },
  dailySummaryEmail: {
    id: "dailySummaryEmail",
    name: "Daily Summary Email",
    type: "service",
  },
  splitView: {
    id: "splitView",
    name: "Split View",
    type: "layout",
  },
  intercom: {
    id: "intercom",
    name: "Intercom",
    type: "service",
  },
};
